import React, { Dispatch, FC, SetStateAction, useEffect, useState } from 'react'
import { produce } from 'immer'
import {
  Card,
  CardBody,
  CardHeader,
  CardSubtitle,
  CardTitle,
  GridLayout,
  GridLayoutItem
} from '@progress/kendo-react-layout'
import {
  Input,
  InputChangeEvent,
  NumericTextBox,
  NumericTextBoxChangeEvent,
  NumericTextBoxHandle,
  TextArea,
  TextAreaChangeEvent
} from '@progress/kendo-react-inputs'
import { Button, ButtonGroup } from '@progress/kendo-react-buttons'
import { Label } from '@progress/kendo-react-labels'
import { Contents } from '../../../components/layouts'
import {
  BranchSelect,
  EvaluationSelect,
  ProcurementStatusSelect,
  ObtainHistorySelect,
  ConstrFormSelect,
  FiscalYearDropDownList,
  ConstrTypeSelect,
  BuildingUsecaseDropDownList,
  StructureTypeSelect,
  AvailabilityStatusSelect,
  UnderGroundConstrMethodSelect,
  FiscalMonthDropDownList,
  DesignClassificationSelect,
  EffortLevelSelect,
  PrefectureSelect
} from '../../../components/parts'
import {
  BasicBuildingInfo,
  BuildingInfoPut,
  BuildingInfoSplit,
  MaintenanceParams
} from '@gateway.Building'
import { Authority } from '../../../gateway/system/Authority'
import { useAppSelector } from '../../../stores'
import dayjs from 'dayjs'
import Constants from '../../../data/Constants.json'

import { MaintenancePageType } from './BuildingMaintenance'
import { Tooltip } from '@progress/kendo-react-tooltip'

const BUILDING_INFO_PUT_INIT: BuildingInfoPut = {
  simulationYm: null,
  buildingNo: null,
  procurementNo: null,
  subNo: null,
  branchCd: null,
  expense: null,
  expenseSeq: null,
  branchNm: null,
  constructionKbn: null,
  constructionKbnNm: null,
  constructionNm: null,
  dispConstructionNm: null,
  opportunityProgressCd: null,
  opportunityProgress: null,
  privateDecisionFlg: null,
  constructionFormCd: null,
  dispConstructionFormCd: null,
  obtainHistoryCd: null,
  dispObtainHistoryCd: null,
  evaluationCd: null,
  evaluation: null,
  evaluationValueCd: null,
  evaluationValue: null,
  customerPartnershipCd: null,
  customerCd: null,
  customerNm: null,
  dispCustomerNm: null,
  collabCustomerPartnershipCd: null,
  collabCustomerCd: null,
  collabCustomerNm: null,
  dispCollabCustomerNm: null,
  designerCustomerPartnershipCd: null,
  designerCustomerCd: null,
  designerNm: null,
  dispDesignerNm: null,
  designKbn: null,
  dispDesignKbn: null,
  designKbnNm: null,
  dispDesignKbnNm: null,
  totalCost: null,
  dispTotalCost: null,
  ourCompanyTotalCost: null,
  dispOurCompanyTotalCost: null,
  ourCompanyEquityRatio: null,
  dispOurCompanyEquityRatio: null,
  obtainYM: null,
  obtainFY: '',
  dispObtainFY: '',
  constructionSubjectCd: null,
  dispConstructionSubjectCd: null,
  constructionSectionCd: null,
  constructionSectionNm: null,
  dispConstructionSectionNm: null,
  chiefPersonCd: null,
  chiefPersonEmployeeNo: null,
  chiefPersonNm: null,
  dispChiefPersonNm: null,
  chiefPersonContacts: null,
  dispChiefPersonContacts: null,
  hqSalesSectionCd: null,
  hqSalesSectionNm: null,
  dispHqSalesSectionNm: null,
  hqSalesPersonCd: null,
  hqSalesPersonEmployeeNo: null,
  hqSalesPersonNm: null,
  dispHqSalesPersonNm: null,
  hqSalesPersonContacts: null,
  dispHqSalesPersonContacts: null,
  branchSalesSectionCd: null,
  branchSalesSectionNm: null,
  dispBranchSalesSectionNm: null,
  branchSalesPersonCd: null,
  branchSalesPersonEmployeeNo: null,
  branchSalesPersonNm: null,
  dispBranchSalesPersonNm: null,
  branchSalesPersonContacts: null,
  dispBranchSalesPersonContacts: null,
  prefecture: null,
  dispPrefecture: null,
  city: null,
  dispCity: null,
  startYM: null,
  dispStartYM: null,
  startY: '',
  startM: '',
  completionYM: null,
  dispCompletionYM: null,
  completionY: '',
  completionM: '',
  schedule: null,
  dispSchedule: null,
  planSummary: null,
  structureCd: null,
  buildingServicesWorkFlg: null,
  dispBuildingServicesWorkFlg: null,
  constructionCd: null,
  dispConstructionCd: null,
  architectureUse: null,
  totalFloorAreaM2: null,
  dispTotalFloorAreaM2: null,
  totalFloorAreaTsubo: null,
  dispTotalFloorAreaTsubo: null,
  siteAreaM2: null,
  dispSiteAreaM2: null,
  siteAreaTsubo: null,
  dispSiteAreaTsubo: null,
  structureUnderGround: null,
  dispStructureUnderGround: null,
  structureGround: null,
  dispStructureGround: null,
  structurePenthouse: null,
  dispStructurePenthouse: null,
  floorUnderGround: null,
  dispFloorUnderGround: null,
  floorGround: null,
  dispFloorGround: null,
  floorPenthouse: null,
  dispFloorPenthouse: null,
  specialConstructionMethod: null,
  dispSpecialConstructionMethod: null,
  piling: null,
  seismicIsolation: null,
  topDownFlg: null,
  fixComment: null,
  architectureUseCd1: null,
  architectureUseNm1: null,
  architectureUseCd2: null,
  architectureUseNm2: null,
  architectureUseCd3: null,
  architectureUseNm3: null,
  analyzationArchitectureUseCd1: null,
  analyzationArchitectureUseNm1: null,
  analyzationArchitectureUseCd2: null,
  analyzationArchitectureUseNm2: null,
  analyzationArchitectureUseCd3: null,
  analyzationArchitectureUseNm3: null,
  effortLevelCd: null,
  dispEffortLevelCd: null,
  effortLevel: null,
  dispEffortLevel: null,
  coreTopFlg: null,
  dispCoreTopFlg: null,
  choiceAndConcentrationTarget: null,
  dispChoiceAndConcentrationTarget: null,
  sagyosyoCd: null,
  dispSagyosyoCd: null,
  yamadumiNotApplicableYm: null,
  importDtm: null,
  addUserKbn: null,
  addDtm: null,
  addUserCd: null,
  updUserKbn: null,
  updDtm: null,
  updUserCd: null,
  delFlg: 0,
  yamadumiFlg: 0,
  kenzaiDiscloseFlg: 0,
  supplierDiscloseFlg: 0,
  completedFlg: 0,
  reportNonTargetFlg: 0,
  procurementSts: null,
  updSts: null,
  remark: null,
  modeKbn: '0'
}

export interface BuildingSplitProps {
  params: MaintenanceParams
  buildingInfoSplitList: BuildingInfoSplit[]
  setBuildingInfoSplitList: Dispatch<SetStateAction<BuildingInfoSplit[]>>
  setSignInBtnDisabled: Dispatch<SetStateAction<boolean>>
  pageType: MaintenancePageType
}
export interface HandleScheduleAutoParams {
  index: number
  sY?: number | null
  sM?: number | null
  cY?: number | null
  cM?: number | null
}
export const BuildingSplit: FC<BuildingSplitProps> = ({
  params,
  buildingInfoSplitList,
  setBuildingInfoSplitList,
  setSignInBtnDisabled,
  pageType
}) => {
  // ログイン情報の取得
  const userProp = useAppSelector((state) => state.common.userProp)

  const common = useAppSelector((x) => x.common)
  const codeNameEvaluations = common.initialData.codeNames('HY01')
  const codeNameBranches = common.initialData.codeNames('SI01')
  const codeNameProcurementSts = common.initialData.codeNames('TY01')
  const codeNameObtainHistory = common.initialData.codeNames('NY01')
  const codeNameConstructionFrom = common.initialData.codeNames('SE01')
  const codeNameDesignKbn = common.initialData.codeNames('SE04')
  const codeNameConstructionCd = common.initialData.codeNames('KO03')
  const codeNameArchitectureUse = common.initialData.codeNames('TA02')
  const codeNameEffortLevelCd = common.initialData.codeNames('TO02')

  // 物件情報一覧
  const searchDataStore = useAppSelector(
    (state) => state.buildingsearch.buildingSearchData
  )
  // 山積対象物件一覧
  const simulationDataStore = useAppSelector(
    (state) => state.simulationbuildingsearch.simulationBuildingList
  )
  // 分割元物件情報
  const [buildingInfoBasicData, setBuildingInfoBasicData] = useState<BasicBuildingInfo>()

  const [buildingInfoPut, setBuildingInfoPut] = useState<BuildingInfoPut>(BUILDING_INFO_PUT_INIT)
  const [obtainFyDisabled, setObtainFyDisabled] = useState(false)

  const [showInputArea, setShowInputArea] = useState(false)

  const [ratioList, setRatioList] = useState([50, 50])

  const systemTime = () => {
    const month = new Date().getMonth() + 1
    const year = new Date().getFullYear()
    const date = month > 9 ? `${year}${month}` : `${year}0${month}`
    return date
  }

  const onShowInputArea = () => {
    splitConstArea()

    if (showInputArea) return

    setShowInputArea(!showInputArea)
  }

  const addRatioList = () => {
    setRatioList([...ratioList, 50])
  }

  const clearRatioList = () => {
    setRatioList(ratioList.slice(1))
  }

  const onChangeRatioList = (
    e: NumericTextBoxChangeEvent,
    targetIndex: number
  ) => {
    const newValue = e.target.value

    if (newValue == null) return

    setRatioList(
      ratioList.map((value: number, index: number) =>
        index === targetIndex ? newValue : value
      )
    )
  }

  const splitConstArea = () => {
    const splitBuildingInfoList: BuildingInfoSplit[] = []
    ratioList.forEach((ratio) => {
      const buildingInfoPutTemp = Object.assign({}, buildingInfoPut)

      // 延床面積㎡
      if (buildingInfoPutTemp.dispTotalFloorAreaM2 !== null) {
        const areaM2 = buildingInfoPutTemp.dispTotalFloorAreaM2 * (ratio * 0.01)
        buildingInfoPutTemp.dispTotalFloorAreaM2 = Number(areaM2.toFixed(3))
        // 延床面積坪
        buildingInfoPutTemp.dispTotalFloorAreaTsubo = Number(
          (areaM2 * 0.3025).toFixed(3)
        )
      }

      // 敷地面積㎡
      if (buildingInfoPutTemp.dispSiteAreaM2 !== null) {
        const areaM2 = buildingInfoPutTemp.dispSiteAreaM2 * (ratio * 0.01)
        buildingInfoPutTemp.dispSiteAreaM2 = Number(areaM2.toFixed(3))
        // 敷地面積坪
        buildingInfoPutTemp.dispSiteAreaTsubo = Number(
          (areaM2 * 0.3025).toFixed(3)
        )
      }

      // 更新ステータス
      buildingInfoPutTemp.updSts = '新規'

      splitBuildingInfoList.push({
        buildingInfo: buildingInfoPutTemp,
        flgChg: 0,
        updDtmBuildingHistoryStatus: null,
        updDtmParentBuildingHistoryStatus: null
      })
    })

    setBuildingInfoSplitList(splitBuildingInfoList)
  }

  const convertFlagValue = (category: string, val: number | null) => {
    if (category === undefined || val === undefined || val === null) {
      return ''
    }
    if (
      category === 'piling' ||
      category === 'seismicIsolation' ||
      category === 'buildingServicesWorkFlg' ||
      category === 'coreTopFlg' ||
      category === 'choiceAndConcentrationTarget'
    ) {
      return Constants.presenceFlag.find((obj) => obj.code === String(val))
        ?.name
    }
    if (category === 'topDown') {
      return Constants.topdownFlag.find((obj) => obj.code === String(val))?.name
    }
    return ''
  }

  /** 延床面積㎡ 延床面積坪 */
  const handleDispTotalFloorAreaM2AndTsubo = (
    index: number,
    value: NumericTextBoxHandle['value']
  ) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispTotalFloorAreaM2 = value ?? 0
        draft[index].buildingInfo.dispTotalFloorAreaTsubo = Number(((value ?? 0) * 0.3025).toFixed(3))
      })
    )
  }

  /** 敷地面積㎡ 敷地面積坪 */
  const handleDispSiteAreaM2AndTsubo = (
    index: number,
    value: NumericTextBoxHandle['value']
  ) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispSiteAreaM2 = value ?? 0
        draft[index].buildingInfo.dispSiteAreaTsubo = Number(((value ?? 0) * 0.3025).toFixed(3))
      })
    )
  }

  /** branchCdList 支店 **/
  const handleBranchCdList = (index: number, val: string[]) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.branchCd = val[0]
        const name = codeNameBranches.find(
          (codeName) => codeName.CODE === val[0]
        )?.NAME
        draft[index].buildingInfo.branchNm = name ?? ''
      })
    )
  }

  /** 評価値 */
  const handleValuationValueCd = (index: number, val: string[]) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.evaluationValueCd = val[0]

        const name = codeNameEvaluations.find(
          (codeName) => codeName.CODE === val[0]
        )?.NAME
        draft[index].buildingInfo.evaluationValue = name ?? ''
      })
    )
  }

  /** 選択と集中対象 */
  const handleChoiceAndConcentrationTarget = (index: number, val: string[]) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispChoiceAndConcentrationTarget = Number(val[0])
      })
    )
  }

  /** 工事名 */
  const handleConstructionNm = (index: number, event: InputChangeEvent) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispConstructionNm = event.value
      })
    )
  }

  /** 調達状況 */
  const handleProcurementSts = (index: number, val: string[]) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.procurementSts = val[0]
      })
    )
  }

  /** 入手経緯 */
  const handleObtainHistoryCd = (index: number, val: string[]) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispObtainHistoryCd = val[0]
      })
    )
  }

  /** 施工形式 */
  const handleConstructionFormCd = (index: number, val: string[]) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispConstructionFormCd = val[0]
      })
    )
  }

  /** 当社持分比 */
  const handleOurCompanyEquityRatio = (
    index: number,
    event: NumericTextBoxChangeEvent
  ) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispOurCompanyEquityRatio = event.value ?? null as unknown as number
      })
    )
  }

  /** 取組レベル */
  const handleEffortLevel = (index: number, val: string[]) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispEffortLevelCd = val[0]

        const name = codeNameEffortLevelCd.find(
          (codeName) => codeName.CODE === val[0]
        )?.NAME
        draft[index].buildingInfo.effortLevel = name ?? ''
      })
    )
  }

  /** コアトップ案件フラグ */
  const handleCoreTopFlg = (index: number, val: string[]) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispCoreTopFlg = Number(val[0])
      })
    )
  }

  /** 入手年度 */
  const handleObtainFy = (index: number, year: number) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispObtainFY = year.toString()
      })
    )
  }

  /** 都道府県名 */
  const handlePrefecture = (index: number, val: string[]) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispPrefecture = val[0]
      })
    )
  }

  /** 市区町村名 */
  const handleCityName = (index: number, event: InputChangeEvent) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispCity = event.value
      })
    )
  }

  /** 工事科目コード */
  const handleConstructionSubjectCd = (
    index: number,
    event: NumericTextBoxChangeEvent
  ) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispConstructionSubjectCd =
          event.value !== null
            ? String(event.value)
            : null as unknown as string
      })
    )
  }

  /** 総工事価格 */
  const handleTotalCost = (index: number, event: NumericTextBoxChangeEvent) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispTotalCost = event.value ?? null as unknown as number
      })
    )
  }

  /** 当社概算工事価格 */
  const handleOurCompanyTotalCost = (
    index: number,
    event: NumericTextBoxChangeEvent
  ) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispOurCompanyTotalCost = event.value ?? null as unknown as number
      })
    )
  }

  /** 工事種別 */
  const handleConstrucionCd = (index: number, val: string[]) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispConstructionCd = val[0]
      })
    )
  }

  /** 建物用途 */
  const handleArchitectureUse = (index: number, val: string) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.architectureUse = val
      })
    )
  }

  /** 構造・地下 */
  const handleDispStructureUnderground = (index: number, val: string[]) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispStructureUnderGround = val[0]
      })
    )
  }

  /** 構造・地上 */
  const handleDispStructureGround = (index: number, val: string[]) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispStructureGround = val[0]
      })
    )
  }

  /** 階数・地下 */
  const handleDispFloorUnderGround = (
    index: number,
    event: NumericTextBoxChangeEvent
  ) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispFloorUnderGround = event.value
      })
    )
  }

  /** 階数・地上 */
  const handleDispFloorGround = (
    index: number,
    event: NumericTextBoxChangeEvent
  ) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispFloorGround = event.value
      })
    )
  }

  /** 階数・塔屋 */
  const handleDispFloorPenthouse = (
    index: number,
    event: NumericTextBoxChangeEvent
  ) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispFloorPenthouse = event.value
      })
    )
  }

  /** 設備工事 */
  const handleDispBuildingServicesWorkFlg = (index: number, val: string[]) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispBuildingServicesWorkFlg = Number(val[0])
      })
    )
  }

  /** 杭打 */
  const handlePiling = (index: number, val: string[]) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.piling = Number(val[0])
      })
    )
  }

  /**  免震 */
  const handleSeismicIsolation = (index: number, val: string[]) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.seismicIsolation = Number(val[0])
      })
    )
  }

  /**  順打逆打 */
  const handleTopDown = (index: number, val: string[]) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.topDownFlg = Number(val[0])
      })
    )
  }

  /** 工法 */
  const handleSpecialConstructionMethodCd = (
    index: number,
    event: InputChangeEvent
  ) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispSpecialConstructionMethod = event.value
      })
    )
  }

  /** 着工年 */
  const handleStartY = (index: number, year: number) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.startY = year.toString()
      })
    )
  }

  /** 着工月 */
  const handleStartM = (index: number, month: number) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.startM = month.toString()
      })
    )
  }

  /** 竣工年 */
  const handleCompletionY = (index: number, year: number) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.completionY = year.toString()
      })
    )
  }

  /** 竣工月 */
  const handleCompletionM = (index: number, month: number) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.completionM = month.toString()
      })
    )
  }

  /**  工期 */
  const handleSchedule = (index: number, event: NumericTextBoxChangeEvent) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispSchedule = event.value ?? 0
      })
    )
  }

  /** 工期計算 */
  const handleScheduleAuto = (params: HandleScheduleAutoParams) => {
    const { index, sY, sM, cY, cM } = params
    const { startY, startM, completionY, completionM } = buildingInfoSplitList[index].buildingInfo
    if (startY !== '' && startM !== '' && completionY !== '' && completionM !== '') {
      const monthesC = Number(cY ?? (completionY ?? 0)) * 12 + (Number(cM ?? (completionM ?? 0)) - 1)
      const monthesS = Number(sY ?? (startY ?? 0)) * 12 + (Number(sM ?? (startM ?? 0)) - 1)
      const diff = monthesC - monthesS + 1
      setBuildingInfoSplitList(
        produce((draft) => {
          draft[index].buildingInfo.dispSchedule = diff ?? 0
        })
      )
    }
  }

  /** 備考 */
  const handleRemark = (index: number, event: TextAreaChangeEvent) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.remark = event.value
      })
    )
  }

  /** 本社営業部名 */
  const handleHqSalesSectionNm = (index: number, event: InputChangeEvent) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispHqSalesSectionNm = event.value
      })
    )
  }

  /** 本社営業担当者名 */
  const handleHqSalesPersonNm = (index: number, event: InputChangeEvent) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispHqSalesPersonNm = event.value
      })
    )
  }

  /** 本社営業担当者連絡先 */
  const handleHqSalesPersonContacts = (
    index: number,
    event: InputChangeEvent
  ) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispHqSalesPersonContacts = event.value
      })
    )
  }

  /** 支店営業部名 */
  const handleBranchSalesSectionNm = (
    index: number,
    event: InputChangeEvent
  ) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispBranchSalesSectionNm = event.value
      })
    )
  }

  /** 支店営業担当者名 */
  const handleBranchSalesPersonNm = (
    index: number,
    event: InputChangeEvent
  ) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispBranchSalesPersonNm = event.value
      })
    )
  }

  /** 支店営業担当者連絡先 */
  const handleBranchSalesPersonContacts = (
    index: number,
    event: InputChangeEvent
  ) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispBranchSalesPersonContacts = event.value
      })
    )
  }

  /** 発注者名 */
  const handleCustomerNm = (index: number, event: InputChangeEvent) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispCustomerNm = event.value
      })
    )
  }

  /** 共同発注者名 */
  const handleCollabCustomerNm = (index: number, event: InputChangeEvent) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispCollabCustomerNm = event.value
      })
    )
  }

  /** 設計区分 */
  const handleDesignKbnNm = (index: number, val: string[]) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispDesignKbn = val[0]

        const name = codeNameDesignKbn.find(
          (codeName) => codeName.CODE === val[0]
        )?.NAME
        draft[index].buildingInfo.dispDesignKbnNm = name ?? ''
      })
    )
  }

  /** 設計者名 */
  const handleInputDesignerNm = (index: number, event: InputChangeEvent) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispDesignerNm = event.value
      })
    )
  }

  /** 修正コメント */
  const handleFixComment = (index: number, event: TextAreaChangeEvent) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.fixComment = event.value
      })
    )
  }

  /** 工事部名 */
  const handleConstructionSectionNm = (
    index: number,
    event: InputChangeEvent
  ) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispConstructionSectionNm = event.value
      })
    )
  }

  /** 所長担当者名 */
  const handleChiefPersonNm = (index: number, event: InputChangeEvent) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispChiefPersonNm = event.value
      })
    )
  }

  /** 所長担当者連絡先 */
  const handleChiefPersonContacts = (
    index: number,
    event: InputChangeEvent
  ) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispChiefPersonContacts = event.value
      })
    )
  }

  /** 作業所コード */
  const handleSagyosyoCd = (
    index: number,
    event: NumericTextBoxChangeEvent
  ) => {
    setBuildingInfoSplitList(
      produce((draft) => {
        draft[index].buildingInfo.dispSagyosyoCd =
          event.value !== null
            ? String(event.value)
            : null as unknown as string
      })
    )
  }

  const style = { padding: '1% 1%' }

  // 画面タイプ＝物件分割の場合
  useEffect(() => {
    if (pageType === MaintenancePageType.SPLIT) {
      for (let i = 0; i < searchDataStore.buildingInfoList.length; i++) {
        const element = searchDataStore.buildingInfoList[i]
        if (
          element.buildingInfo.procurementNo === params.procurementNo &&
          element.buildingInfo.subNo === params.subNo &&
          element.buildingInfo.branchCd === params.branchCd
        ) {
          const buildingInfo = element.buildingInfo
          setBuildingInfoBasicData(
            {
              /** 支店コード */
              branchCd: buildingInfo.branchCd,
              /** 支店名 */
              branchStr: buildingInfo.branchNm,
              /** 費目 */
              expense: null,
              /** 費目連番 */
              expenseSeq: null,
              /** 調達番号 */
              procurementNo: buildingInfo.procurementNo ?? '',
              /** 枝番（子） */
              subNo: buildingInfo.subNo ?? '',
              /** 物件番号 */
              buildingNo: null,
              /** 土建区分 */
              constructionKbn: buildingInfo.constructionKbn,
              /** 土建区分名 */
              constructionKbnNm: buildingInfo.constructionKbnNm,
              /** 評価コード */
              evaluationCd: buildingInfo.evaluationCd,
              /** 評価 */
              evaluation: buildingInfo.evaluation,
              /** 評価値コード */
              evaluationValueCd: buildingInfo.evaluationValueCd,
              /** 評価値 */
              evaluationValue: buildingInfo.evaluationValue,
              /** 更新ステータスコード */
              updSts: buildingInfo.updSts,
              /** 更新ステータス */
              updStsStr: buildingInfo.updStsStr,
              /** 更新日時 */
              updDtm: buildingInfo.updDtm,
              /** 更新者区分 */
              updUserKbnStr: buildingInfo.updUserKbnStr,
              /** 更新者名 */
              updUserNm: buildingInfo.updUserStr,
              /** 工事名 */
              constructionNm: buildingInfo.dispConstructionNm,
              /** 物件進捗状況コード */
              opportunityProgressCd: buildingInfo.opportunityProgressCd,
              /** 物件進捗状況 */
              opportunityProgress: buildingInfo.opportunityProgress,
              /** 内定フラグ */
              privateDecisionFlg: buildingInfo.privateDecisionFlg,
              /** 調達状況コード */
              procurementStsCd: buildingInfo.procurementSts,
              /** 調達状況 */
              procurementStsStr: buildingInfo.procurementStsStr,
              /** 入手経緯コード */
              obtainHistoryCd: buildingInfo.dispObtainHistoryCd,
              /** 入手経緯 */
              obtainHistoryStr: buildingInfo.dispObtainHistoryStr,
              /** 施工形式コード */
              constructionFormCd: buildingInfo.dispConstructionFormCd,
              /** 施工形式 */
              constructionFormStr: buildingInfo.dispConstructionFormStr,
              /** 当社持分比 */
              ourCompanyEquityRatio: buildingInfo.dispOurCompanyEquityRatio,
              /** 入手年度 */
              obtainFy: buildingInfo.dispObtainFY,
              /** 都道府県名 */
              prefecture: buildingInfo.dispPrefecture,
              /** 市区町村名 */
              city: buildingInfo.dispCity,
              /** 工事科目コード */
              constructionSubjectCd: buildingInfo.dispConstructionSubjectCd,
              /** 総工事価格 */
              totalCost: buildingInfo.dispTotalCost !== null && buildingInfo.dispTotalCost !== undefined && buildingInfo.dispTotalCost !== 0
                ? buildingInfo.dispTotalCost / 1000000
                : buildingInfo.dispTotalCost,
              /** 当社概算工事価格 */
              ourCompanyTotalCost: buildingInfo.dispOurCompanyTotalCost !== null && buildingInfo.dispOurCompanyTotalCost !== undefined && buildingInfo.dispOurCompanyTotalCost !== 0
                ? buildingInfo.dispOurCompanyTotalCost / 1000000
                : buildingInfo.dispOurCompanyTotalCost,
              /** 工事種別コード */
              constructionCd: buildingInfo.dispConstructionCd,
              /** 工事種別 */
              constructionStr: buildingInfo.dispConstructionStr,
              /** 建物用途コード */
              architectureUseCd: buildingInfo.architectureUse,
              /** 建物用途 */
              architectureUseStr: buildingInfo.architectureUseStr,
              /** 構造・地下コード */
              structureUnderGroundCd: buildingInfo.dispStructureUnderGround,
              /** 構造・地下 */
              structureUnderGroundStr: buildingInfo.dispStructureUnderGroundStr,
              /** 構造・地上コード */
              structureGroundCd: buildingInfo.dispStructureGround,
              /** 構造・地上 */
              structureGroundStr: buildingInfo.dispStructureGroundStr,
              /** 延床面積平米 */
              totalFloorAreaM2: buildingInfo.dispTotalFloorAreaM2,
              /** 延床面積坪 */
              totalFloorAreaTsubo: buildingInfo.dispTotalFloorAreaTsubo,
              /** 敷地面積平米 */
              siteAreaM2: buildingInfo.dispSiteAreaM2,
              /** 敷地面積坪 */
              siteAreaTsubo: buildingInfo.dispSiteAreaTsubo,
              /** 階数・地下 */
              floorUnderGround: buildingInfo.dispFloorUnderGround,
              /** 階数・地上 */
              floorGround: buildingInfo.dispFloorGround,
              /** 階数・塔屋 */
              floorPenthouse: buildingInfo.dispFloorPenthouse,
              /** 設備工事有無 */
              buildingServicesWorkFlg: buildingInfo.dispBuildingServicesWorkFlg,
              /** 杭打 */
              piling: buildingInfo.piling,
              /** 免震 */
              seismicIsolation: buildingInfo.seismicIsolation,
              /** 順打逆打 */
              topDown: buildingInfo.topDownFlg,
              /** 特殊工法 */
              specialConstructionMethod: buildingInfo.specialConstructionMethod,
              /** 着工年月 */
              startYM: buildingInfo.dispStartYM,
              /** 竣工年月 */
              completionYM: buildingInfo.dispCompletionYM,
              /** 工期 */
              schedule: buildingInfo.dispSchedule,
              /** 備考 */
              remark: buildingInfo.remark,
              /** 工事部コード */
              constructionSectionCd: buildingInfo.constructionSectionCd,
              /** 工事部名 */
              constructionSectionNm: buildingInfo.dispConstructionSectionNm,
              /** 所長担当者コード */
              chiefPersonCd: buildingInfo.chiefPersonCd,
              /** 所長担当者従業員番号 */
              chiefPersonEmployeeNo: buildingInfo.chiefPersonEmployeeNo,
              /** 所長担当者名 */
              chiefPersonNm: buildingInfo.dispChiefPersonNm,
              /** 所長担当者連絡先 */
              chiefPersonContacts: buildingInfo.dispChiefPersonContacts,
              /** 本社営業部コード */
              hqSalesSectionCd: buildingInfo.hqSalesSectionCd,
              /** 本社営業部名 */
              hqSalesSectionNm: buildingInfo.dispHqSalesSectionNm,
              /** 本社営業担当者コード */
              hqSalesPersonCd: buildingInfo.hqSalesPersonCd,
              /** 本社営業担当者従業員番号 */
              hqSalesPersonEmployeeNo: buildingInfo.hqSalesPersonEmployeeNo,
              /** 本社営業担当者名 */
              hqSalesPersonNm: buildingInfo.dispHqSalesPersonNm,
              /** 本社営業担当者連絡先 */
              hqSalesPersonContacts: buildingInfo.dispHqSalesPersonContacts,
              /** 支店営業部コード */
              branchSalesSectionCd: buildingInfo.branchSalesSectionCd,
              /** 支店営業部名 */
              branchSalesSectionNm: buildingInfo.dispBranchSalesSectionNm,
              /** 支店営業担当者コード */
              branchSalesPersonCd: buildingInfo.branchSalesPersonCd,
              /** 支店営業担当者従業員番号 */
              branchSalesPersonEmployeeNo: buildingInfo.branchSalesPersonEmployeeNo,
              /** 支店営業担当者名 */
              branchSalesPersonNm: buildingInfo.dispBranchSalesPersonNm,
              /** 支店営業担当者連絡先 */
              branchSalesPersonContacts: buildingInfo.dispBranchSalesPersonContacts,
              /** 発注者統合企業コード */
              customerPartnershipCd: buildingInfo.customerPartnershipCd,
              /** 発注者取引先コード */
              customerCd: buildingInfo.customerCd,
              /** 発注者名 */
              customerNm: buildingInfo.dispCustomerNm,
              /** 共同発注者統合企業コード */
              collabCustomerPartnershipCd: buildingInfo.collabCustomerPartnershipCd,
              /** 共同発注者取引先コード */
              collabCustomerCd: buildingInfo.collabCustomerCd,
              /** 共同発注者名 */
              collabCustomerNm: buildingInfo.dispCollabCustomerNm,
              /** 設計区分コード */
              designKbnNmCd: buildingInfo.dispDesignKbn,
              /** 設計区分 */
              designKbnNmStr: buildingInfo.designKbnNm,
              /** 設計者統合企業コード */
              designerCustomerPartnershipCd: buildingInfo.designerCustomerPartnershipCd,
              /** 設計者取引先コード */
              designerCustomerCd: buildingInfo.designerCustomerCd,
              /** 設計者名 */
              designerNm: buildingInfo.dispDesignerNm,
              /** 山積対象フラグ */
              yamadumiFlg: 0,
              /** 建材部公開フラグ */
              kenzaiDiscloseFlg: 0,
              /** 業者公開フラグ */
              supplierDiscloseFlg: 0,
              /** 修正コメント */
              fixComment: null,
              /** 建築用途分類コード１ */
              architectureUseCd1: buildingInfo.architectureUseCd1,
              /** 建築用途分類名１ */
              architectureUseNm1: buildingInfo.architectureUseNm1,
              /** 建築用途分類コード2 */
              architectureUseCd2: buildingInfo.architectureUseCd2,
              /** 建築用途分類2 */
              architectureUseNm2: buildingInfo.architectureUseNm2,
              /** 建築用途分類コード3 */
              architectureUseCd3: buildingInfo.architectureUseCd3,
              /** 建築用途分類3 */
              architectureUseNm3: buildingInfo.architectureUseNm3,
              /** 分析用建築用途分類コード１ */
              analyzationArchitectureUseCd1: buildingInfo.analyzationArchitectureUseCd1,
              /** 分析用建築用途分類名１ */
              analyzationArchitectureUseNm1: buildingInfo.analyzationArchitectureUseNm1,
              /** 分析用建築用途分類コード2 */
              analyzationArchitectureUseCd2: buildingInfo.analyzationArchitectureUseCd2,
              /** 分析用建築用途分類名2 */
              analyzationArchitectureUseNm2: buildingInfo.analyzationArchitectureUseNm2,
              /** 分析用建築用途分類コード3 */
              analyzationArchitectureUseCd3: buildingInfo.analyzationArchitectureUseCd3,
              /** 分析用建築用途分類名3 */
              analyzationArchitectureUseNm3: buildingInfo.analyzationArchitectureUseNm3,
              /** 取組レベルコード */
              effortLevelCd: buildingInfo.dispEffortLevelCd,
              /** 取組レベル */
              effortLevelStr: buildingInfo.dispEffortLevel,
              /** コアトップ案件フラグ */
              coreTopFlg: buildingInfo.dispCoreTopFlg,
              /** 選択と集中対象 */
              choiceAndConcentrationTarget: buildingInfo.dispChoiceAndConcentrationTarget,
              /** 作業所コード */
              sagyosyoCd: buildingInfo.dispSagyosyoCd,
              /** 山積対象外年月 */
              yamadumiNotApplicableYm: null,
              /** 取込日時 */
              importDtm: null,
              /** 登録者区分 */
              addUserKbn: null,
              /** 登録日時 */
              addDtm: null
            }
          )

          const putObj = {
            ...buildingInfo,
            startY: buildingInfo.dispStartYM === null ? '' : buildingInfo.dispStartYM.substring(0, 4),
            startM: buildingInfo.dispStartYM === null ? '' : buildingInfo.dispStartYM.substring(4, 6),
            completionY: buildingInfo.dispCompletionYM === null ? '' : buildingInfo.dispCompletionYM.substring(0, 4),
            completionM: buildingInfo.dispCompletionYM === null ? '' : buildingInfo.dispCompletionYM.substring(4, 6),
            // 初期値は円単位を百万単位に変換する
            dispTotalCost:
              buildingInfo.dispTotalCost !== null && buildingInfo.dispTotalCost !== undefined && buildingInfo.dispTotalCost !== 0
                ? buildingInfo.dispTotalCost / 1000000
                : buildingInfo.dispTotalCost,
            dispOurCompanyTotalCost:
              buildingInfo.dispOurCompanyTotalCost !== null && buildingInfo.dispOurCompanyTotalCost !== undefined && buildingInfo.dispOurCompanyTotalCost !== 0
                ? buildingInfo.dispOurCompanyTotalCost / 1000000
                : buildingInfo.dispOurCompanyTotalCost,
            yamadumiNotApplicableYm: null,
            /** シミュレーション年月度 */
            simulationYm: null,
            /** 費目 */
            expense: null,
            /** 費目連番 */
            expenseSeq: null,
            /** 取込日時 */
            importDtm: null,
            /** 登録者区分 */
            addUserKbn: null,
            /** 登録日時 */
            addDtm: null,
            /** 更新日時 */
            updDtm: null,
            /** 山積対象フラグ */
            yamadumiFlg: 0,
            /** 建材部公開フラグ */
            kenzaiDiscloseFlg: 0,
            /** 業者公開フラグ */
            supplierDiscloseFlg: 0,
            /** 備考 */
            remark: null,
            /** 修正コメント */
            fixComment: null,
            /** モード区分 */
            modeKbn: null
          }
          setBuildingInfoPut(putObj)

          break
        }
      }
      setSignInBtnDisabled(false)
    }
  }, [
    pageType,
    params.branchCd,
    params.procurementNo,
    params.subNo,
    searchDataStore.buildingInfoList
  ])
  // 画面タイプ＝費目分割登録の場合
  useEffect(() => {
    if (pageType === MaintenancePageType.EXPENSE_SPLIT) {
      for (let i = 0; i < simulationDataStore.length; i++) {
        const element = simulationDataStore[i]
        if (
          element.procurementNo === params.procurementNo &&
          element.subNo === params.subNo &&
          element.branchCd === params.branchCd &&
          element.expense === params.expenseCode &&
          element.expenseSeq === params.expenseSeq
        ) {
          const buildingInfo = element
          setBuildingInfoBasicData({
            /** 支店コード */
            branchCd: buildingInfo.branchCd,
            /** 支店名 */
            branchStr: buildingInfo.branchNm,
            /** 調達番号 */
            procurementNo: buildingInfo.procurementNo ?? '',
            /** 枝番（子） */
            subNo: buildingInfo.subNo ?? '',
            /** 費目 */
            expense: buildingInfo.expense ?? '',
            /** 費目連番 */
            expenseSeq: buildingInfo.expenseSeq ?? '',
            /** 物件番号 */
            buildingNo: null,
            /** 更新者名 */
            updUserNm: null,
            /** 更新者区分 */
            updUserKbnStr: '',
            /** 土建区分 */
            constructionKbn: buildingInfo.constructionKbn,
            /** 土建区分名 */
            constructionKbnNm: buildingInfo.constructionKbnNm,
            /** 評価コード */
            evaluationCd: buildingInfo.evaluationCd,
            /** 評価 */
            evaluation: buildingInfo.evaluation,
            /** 評価値コード */
            evaluationValueCd: buildingInfo.evaluationValueCd ?? '',
            /** 評価値 */
            evaluationValue: buildingInfo.evaluationValue,
            /** 更新ステータスコード */
            updSts: buildingInfo.updSts,
            /** 更新ステータス */
            updStsStr: buildingInfo.updStsNm,
            /** 更新日時 */
            updDtm: buildingInfo.updDtm,
            /** 工事名 */
            constructionNm: buildingInfo.dispConstructionNm,
            /** 物件進捗状況コード */
            opportunityProgressCd: null,
            /** 物件進捗状況 */
            opportunityProgress: buildingInfo.opportunityProgress,
            /** 内定フラグ */
            privateDecisionFlg: null,
            /** 調達状況コード */
            procurementStsCd: buildingInfo.procurementSts,
            /** 調達状況 */
            procurementStsStr: codeNameProcurementSts.find(v => v.CODE === buildingInfo.procurementSts)?.NAME ?? '',
            /** 入手経緯コード */
            obtainHistoryCd: buildingInfo.dispObtainHistoryCd,
            /** 入手経緯 */
            obtainHistoryStr: codeNameObtainHistory.find(v => v.CODE === buildingInfo.dispObtainHistoryCd)?.NAME ?? '',
            /** 施工形式コード */
            constructionFormCd: buildingInfo.dispConstructionFormCd,
            /** 施工形式 */
            constructionFormStr: codeNameConstructionFrom.find(v => v.CODE === buildingInfo.dispConstructionFormCd)?.NAME ?? '',
            /** 当社持分比 */
            ourCompanyEquityRatio: buildingInfo.dispOurCompanyEquityRatio,
            /** 入手年度 */
            obtainFy: buildingInfo.obtainFY ?? '',
            /** 都道府県名 */
            prefecture: buildingInfo.dispPrefecture,
            /** 市区町村名 */
            city: buildingInfo.dispCity,
            /** 工事科目コード */
            constructionSubjectCd: buildingInfo.dispConstructionSubjectCd,
            /** 総工事価格 */
            totalCost: buildingInfo.totalCost !== null && buildingInfo.totalCost !== undefined && buildingInfo.totalCost !== 0
              ? buildingInfo.totalCost / 1000000
              : buildingInfo.totalCost,
            /** 当社概算工事価格 */
            ourCompanyTotalCost: buildingInfo.ourCompanyTotalCost !== null && buildingInfo.ourCompanyTotalCost !== undefined && buildingInfo.ourCompanyTotalCost !== 0
              ? buildingInfo.ourCompanyTotalCost / 1000000
              : buildingInfo.ourCompanyTotalCost,
            /** 工事種別コード */
            constructionCd: buildingInfo.constructionCd,
            /** 工事種別 */
            constructionStr: codeNameConstructionCd.find(v => v.CODE === buildingInfo.constructionCd)?.NAME ?? '',
            /** 建物用途コード */
            architectureUseCd: buildingInfo.architectureUse,
            /** 建物用途 */
            architectureUseStr: codeNameArchitectureUse.find(v => v.CODE === buildingInfo.architectureUse)?.NAME ?? '',
            /** 構造・地下コード */
            structureUnderGroundCd: buildingInfo.dispStructureUnderGround,
            /** 構造・地下 */
            structureUnderGroundStr: buildingInfo.structureUnderGroundNm,
            /** 構造・地上コード */
            structureGroundCd: buildingInfo.dispStructureGround,
            /** 構造・地上 */
            structureGroundStr: buildingInfo.structureGroundNm,
            /** 延床面積平米 */
            totalFloorAreaM2: buildingInfo.dispTotalFloorAreaM2,
            /** 延床面積坪 */
            totalFloorAreaTsubo: buildingInfo.dispTotalFloorAreaTsubo,
            /** 敷地面積平米 */
            siteAreaM2: buildingInfo.dispSiteAreaM2,
            /** 敷地面積坪 */
            siteAreaTsubo: buildingInfo.dispSiteAreaTsubo,
            /** 階数・地下 */
            floorUnderGround: buildingInfo.dispFloorUnderGround,
            /** 階数・地上 */
            floorGround: buildingInfo.dispFloorGround,
            /** 階数・塔屋 */
            floorPenthouse: buildingInfo.dispFloorPenthouse,
            /** 設備工事有無 */
            buildingServicesWorkFlg: buildingInfo.dispBuildingServicesWorkFlg,
            /** 杭打 */
            piling: buildingInfo.piling,
            /** 免震 */
            seismicIsolation: buildingInfo.seismicIsolation,
            /** 順打逆打 */
            topDown: buildingInfo.topDownFlg,
            /** 特殊工法 */
            specialConstructionMethod: buildingInfo.dispSpecialConstructionMethod,
            /** 着工年月 */
            startYM: buildingInfo.dispStartYM,
            /** 竣工年月 */
            completionYM: buildingInfo.dispCompletionYM,
            /** 工期 */
            schedule: buildingInfo.dispSchedule,
            /** 備考 */
            remark: buildingInfo.remark,
            /** 工事部コード */
            constructionSectionCd: buildingInfo.constructionSectionCd,
            /** 工事部名 */
            constructionSectionNm: buildingInfo.dispConstructionSectionNm,
            /** 所長担当者コード */
            chiefPersonCd: buildingInfo.chiefPersonCd,
            /** 所長担当者従業員番号 */
            chiefPersonEmployeeNo: buildingInfo.chiefPersonEmployeeNo,
            /** 所長担当者名 */
            chiefPersonNm: buildingInfo.dispChiefPersonNm,
            /** 所長担当者連絡先 */
            chiefPersonContacts: buildingInfo.dispChiefPersonContacts,
            /** 本社営業部コード */
            hqSalesSectionCd: buildingInfo.hqSalesSectionCd,
            /** 本社営業部名 */
            hqSalesSectionNm: buildingInfo.dispHqSalesSectionNm,
            /** 本社営業担当者コード */
            hqSalesPersonCd: buildingInfo.hqSalesPersonCd,
            /** 本社営業担当者従業員番号 */
            hqSalesPersonEmployeeNo: buildingInfo.hqSalesPersonEmployeeNo,
            /** 本社営業担当者名 */
            hqSalesPersonNm: buildingInfo.dispHqSalesPersonNm,
            /** 本社営業担当者連絡先 */
            hqSalesPersonContacts: buildingInfo.dispHqSalesPersonContacts,
            /** 支店営業部コード */
            branchSalesSectionCd: buildingInfo.branchSalesSectionCd,
            /** 支店営業部名 */
            branchSalesSectionNm: buildingInfo.dispBranchSalesSectionNm,
            /** 支店営業担当者コード */
            branchSalesPersonCd: buildingInfo.branchSalesPersonCd,
            /** 支店営業担当者従業員番号 */
            branchSalesPersonEmployeeNo: buildingInfo.branchSalesPersonEmployeeNo,
            /** 支店営業担当者名 */
            branchSalesPersonNm: buildingInfo.dispBranchSalesPersonNm,
            /** 支店営業担当者連絡先 */
            branchSalesPersonContacts: buildingInfo.dispBranchSalesPersonContacts,
            /** 発注者統合企業コード */
            customerPartnershipCd: null,
            /** 発注者取引先コード */
            customerCd: null,
            /** 発注者名 */
            customerNm: buildingInfo.dispCustomerNm,
            /** 共同発注者統合企業コード */
            collabCustomerPartnershipCd: null,
            /** 共同発注者取引先コード */
            collabCustomerCd: null,
            /** 共同発注者名 */
            collabCustomerNm: buildingInfo.dispCollabCustomerNm,
            /** 設計区分コード */
            designKbnNmCd: buildingInfo.dispDesignKbn ?? '',
            /** 設計区分 */
            designKbnNmStr: buildingInfo.dispDesignKbnNm ?? '',
            /** 設計者統合企業コード */
            designerCustomerPartnershipCd: null,
            /** 設計者取引先コード */
            designerCustomerCd: null,
            /** 設計者名 */
            designerNm: buildingInfo.dispDesignerNm,
            /** 山積対象フラグ */
            yamadumiFlg: buildingInfo.yamadumiFlg,
            /** 建材部公開フラグ */
            kenzaiDiscloseFlg: buildingInfo.kenzaiDiscloseFlg,
            /** 業者公開フラグ */
            supplierDiscloseFlg: buildingInfo.supplierDiscloseFlg,
            /** 修正コメント */
            fixComment: null,
            /** 建築用途分類コード１ */
            architectureUseCd1: null,
            /** 建築用途分類名１ */
            architectureUseNm1: null,
            /** 建築用途分類コード2 */
            architectureUseCd2: null,
            /** 建築用途分類2 */
            architectureUseNm2: null,
            /** 建築用途分類コード3 */
            architectureUseCd3: null,
            /** 建築用途分類3 */
            architectureUseNm3: null,
            /** 分析用建築用途分類コード１ */
            analyzationArchitectureUseCd1: null,
            /** 分析用建築用途分類名１ */
            analyzationArchitectureUseNm1: null,
            /** 分析用建築用途分類コード2 */
            analyzationArchitectureUseCd2: null,
            /** 分析用建築用途分類名2 */
            analyzationArchitectureUseNm2: null,
            /** 分析用建築用途分類コード3 */
            analyzationArchitectureUseCd3: null,
            /** 分析用建築用途分類名3 */
            analyzationArchitectureUseNm3: null,
            /** 取組レベルコード */
            effortLevelCd: buildingInfo.dispEffortLevelCd,
            /** 取組レベル */
            effortLevelStr: buildingInfo.dispEffortLevel ?? '',
            /** コアトップ案件フラグ */
            coreTopFlg: buildingInfo.dispCoreTopFlg,
            /** 選択と集中対象 */
            choiceAndConcentrationTarget: buildingInfo.dispChoiceAndConcentrationTarget,
            /** 作業所コード */
            sagyosyoCd: buildingInfo.dispSagyosyoCd,
            /** 山積対象外年月 */
            yamadumiNotApplicableYm: null,
            /** 取込日時 */
            importDtm: null,
            /** 登録者区分 */
            addUserKbn: null,
            /** 登録日時 */
            addDtm: null
          })

          const putObj = {
            ...buildingInfo,
            /** 着工年 */
            startY: buildingInfo.dispStartYM === null ? '' : buildingInfo.dispStartYM.substring(0, 4),
            /** 着工月 */
            startM: buildingInfo.dispStartYM === null ? '' : buildingInfo.dispStartYM.substring(4, 6),
            /** 竣工年 */
            completionY: buildingInfo.dispCompletionYM === null ? '' : buildingInfo.dispCompletionYM.substring(0, 4),
            /** 竣工月 */
            completionM: buildingInfo.dispCompletionYM === null ? '' : buildingInfo.dispCompletionYM.substring(4, 6),
            // 初期値は円単位を百万単位に変換する
            /** 総工事価格 */
            dispTotalCost:
              buildingInfo.dispTotalCost !== null && buildingInfo.dispTotalCost !== undefined && buildingInfo.dispTotalCost !== 0
                ? buildingInfo.dispTotalCost / 1000000
                : buildingInfo.dispTotalCost,
            /** 当社概算工事価格 */
            dispOurCompanyTotalCost:
              buildingInfo.dispOurCompanyTotalCost !== null && buildingInfo.dispOurCompanyTotalCost !== undefined && buildingInfo.dispOurCompanyTotalCost !== 0
                ? buildingInfo.dispOurCompanyTotalCost / 1000000
                : buildingInfo.dispOurCompanyTotalCost,
            /** 山積対象外年月 */
            yamadumiNotApplicableYm: null,
            /** シミュレーション年月度 */
            simulationYm: systemTime(),
            /** 費目連番 */
            expenseSeq: null,
            /** 取込日時 */
            importDtm: null,
            /** 登録者区分 */
            addUserKbn: null,
            /** 登録日時 */
            addDtm: null,
            /** 更新日時 */
            updDtm: null,
            /** 山積対象フラグ */
            yamadumiFlg: 1,
            /** 建材部公開フラグ */
            kenzaiDiscloseFlg: 1,
            /** 業者公開フラグ */
            supplierDiscloseFlg: 0,
            /** 更新ステータス */
            updSts: buildingInfo.updSts ?? null,
            /** 備考 */
            remark: null,
            /** 修正コメント */
            fixComment: null,
            /** モード区分 */
            modeKbn: '1'
          }

          setBuildingInfoPut(putObj)
          break
        }
      }
      // 登録ボタンを活性にする
      setSignInBtnDisabled(false)
    }
  }, [
    pageType,
    params.branchCd,
    params.procurementNo,
    params.subNo,
    simulationDataStore
  ])
  useEffect(() => {
    // 画面タイプ＝物件分割、費目内分割、利用者権限＝工務、建材部、支店
    // 調達番号、入手年度は編集不可 その他の項目は編集可
    if (
      userProp?.authority === Authority.Builder ||
      userProp?.authority === Authority.Material ||
      userProp?.authority === Authority.Branch
    ) {
      // 入手年度を編集不可に設定する
      setObtainFyDisabled(true)
    } else {
      // 入手年度を編集可に設定する
      setObtainFyDisabled(false)
    }
  }, [userProp?.authority])

  const procurementNo = pageType === MaintenancePageType.EXPENSE_SPLIT
    ? `${buildingInfoBasicData?.procurementNo ?? ''}-${buildingInfoBasicData?.subNo ?? ''}-${buildingInfoBasicData?.expense ?? ''}-${buildingInfoBasicData?.expenseSeq ?? ''}`
    : `${buildingInfoBasicData?.procurementNo ?? ''}-${buildingInfoBasicData?.subNo ?? ''}`

  return (
    <Contents>
      <>
        <Label style={{ fontWeight: 'bold' }}>分割元物件情報</Label>
        <Card orientation="horizontal" style={{ margin: '10px 0px' }}>
          <CardHeader style={style}>
            <CardTitle style={{ marginTop: '0px' }}>
              <span
                style={{
                  fontSize: '1.25em',
                  fontWeight: 'bold',
                  color: 'gray'
                }}
              >
                {buildingInfoBasicData?.branchStr}
              </span>
            </CardTitle>
            <CardSubtitle style={{ marginTop: '0px' }}>
              <span
                style={{ fontSize: '1em', fontWeight: 'bold', color: 'gray' }}
              >
                {procurementNo}
              </span>
            </CardSubtitle>
            <CardSubtitle style={{ marginTop: '0px' }}>
              <span
                style={{ fontSize: '1em', fontWeight: 'bold', color: 'gray' }}
              >
                {buildingInfoBasicData?.buildingNo}
              </span>
            </CardSubtitle>
            <CardSubtitle style={{ marginTop: '0px' }}>
              <span
                style={{
                  fontSize: '1.25em',
                  fontWeight: 'bold',
                  color: 'gray'
                }}
              >
                {buildingInfoBasicData?.evaluationValue}
              </span>
            </CardSubtitle>
            <CardSubtitle style={{ marginTop: '0px' }}>
              <span
                style={{
                  fontSize: '1.25em',
                  fontWeight: 'bold',
                  color: 'gray'
                }}
              >
                {'選択と集中：'}
              </span>
              <span
                style={{
                  fontSize: '1.25em',
                  fontWeight: 'bold',
                  color: 'gray'
                }}
              >
                {convertFlagValue('choiceAndConcentrationTarget', buildingInfoBasicData?.choiceAndConcentrationTarget ?? null)}
              </span>
            </CardSubtitle>
            <CardSubtitle style={{ marginTop: '0px' }}>
              <span
                style={{
                  fontSize: '1.25em',
                  fontWeight: 'bold',
                  color: 'gray'
                }}
              >
                {buildingInfoBasicData?.updStsStr}
              </span>
            </CardSubtitle>
            <CardSubtitle style={{ marginTop: '0px' }}>
              <span
                style={{ fontSize: '0.8em', fontWeight: 'bold', color: 'gray' }}
              >
                {dayjs(buildingInfoBasicData?.updDtm).format('YYYY/MM/DD hh:mm')}
              </span>
            </CardSubtitle>
            <CardSubtitle style={{ marginTop: '0px' }}>
                <span
                  style={{
                    fontSize: '0.8em',
                    fontWeight: 'bold',
                    color: 'gray'
                  }}
                >
                  {buildingInfoBasicData?.updUserKbnStr}
                </span>
                <span
                  style={{
                    fontSize: '0.8em',
                    fontWeight: 'bold',
                    color: 'gray'
                  }}
                >
                  /
                </span>
                <span
                  style={{
                    fontSize: '0.8em',
                    fontWeight: 'bold',
                    color: 'gray'
                  }}
                >
                  {buildingInfoBasicData?.updUserNm}
                </span>
            </CardSubtitle>
          </CardHeader>
          <CardBody style={style}>
            <GridLayout gap={{ cols: 10 }}>
              <GridLayoutItem
                col={2}
                style={{ marginLeft: 10, marginRight: 10 }}
              >
                <GridLayout>
                  <GridLayoutItem col={1} colSpan={3} row={1}>
                    <span style={{ fontWeight: 'normal', fontSize: '1.0em' }}>
                      {buildingInfoBasicData?.constructionNm}
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem col={1} colSpan={3} row={2}>
                    <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                      {buildingInfoBasicData?.constructionSubjectCd}{' '}
                      {buildingInfoBasicData?.procurementStsStr}{' '}
                      {buildingInfoBasicData?.obtainHistoryStr}{' '}
                      {buildingInfoBasicData?.constructionFormStr}{' '}
                      {buildingInfoBasicData?.ourCompanyEquityRatio !== null ? `${buildingInfoBasicData?.ourCompanyEquityRatio ?? ''}%` : ''}
                      {buildingInfoBasicData?.effortLevelStr}{' '}
                      コアトップ案件:{convertFlagValue(
                        'coreTopFlg',
                        buildingInfoBasicData?.coreTopFlg ?? null
                      )}{' '}
                      {buildingInfoBasicData?.obtainFy}{' '}
                      {buildingInfoBasicData?.prefecture}{' '}
                      {buildingInfoBasicData?.city}{' '}
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem col={1} colSpan={3} row={3}>
                    <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                      総工事金額（百万）:￥{buildingInfoBasicData?.totalCost?.toLocaleString() ?? ''}{' '}
                      当社概算工事金額（百万）:￥{buildingInfoBasicData?.ourCompanyTotalCost?.toLocaleString() ?? ''}
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem col={1} colSpan={3} row={4}>
                    <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                      {buildingInfoBasicData?.constructionStr}{' '}
                      {buildingInfoBasicData?.architectureUseStr}（
                      {buildingInfoBasicData?.structureUnderGroundStr}/
                      {buildingInfoBasicData?.structureGroundStr}）
                      {buildingInfoBasicData?.totalFloorAreaM2?.toLocaleString() ?? ''}㎡/
                      {buildingInfoBasicData?.totalFloorAreaTsubo?.toLocaleString() ?? ''}坪 -（
                      {buildingInfoBasicData?.floorUnderGround}/
                      {buildingInfoBasicData?.floorGround}/
                      {buildingInfoBasicData?.floorPenthouse}）
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem col={1} colSpan={3} row={5}>
                    <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                      設備工事:
                      {convertFlagValue(
                        'buildingServicesWorkFlg',
                        buildingInfoBasicData?.buildingServicesWorkFlg ?? null
                      )}{' '}
                      杭打:
                      {convertFlagValue(
                        'piling',
                        buildingInfoBasicData?.piling ?? null
                      )}{' '}
                      免震:
                      {convertFlagValue(
                        'seismicIsolation',
                        buildingInfoBasicData?.seismicIsolation ?? null
                      )}{' '}
                      {convertFlagValue(
                        'topDown',
                        buildingInfoBasicData?.topDown ?? null
                      )}{' '}
                      工法:
                      {buildingInfoBasicData?.specialConstructionMethod}
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem col={1} colSpan={3} row={6}>
                    <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                      {buildingInfoBasicData?.startYM !== null
                        ? buildingInfoBasicData?.startYM.substring(0, 4)
                        : ''}
                      {'/'}
                      {buildingInfoBasicData?.startYM !== null
                        ? buildingInfoBasicData?.startYM.substring(4, 6)
                        : ''}
                      -
                      {buildingInfoBasicData?.completionYM !== null
                        ? buildingInfoBasicData?.completionYM.substring(0, 4)
                        : ''}
                      {'/'}
                      {buildingInfoBasicData?.completionYM !== null
                        ? buildingInfoBasicData?.completionYM.substring(4, 6)
                        : ''}{' '}
                      {buildingInfoBasicData?.schedule}ヶ月
                      {'  '}
                      {buildingInfoBasicData?.siteAreaM2?.toLocaleString() ?? ''}㎡/
                      {buildingInfoBasicData?.siteAreaTsubo?.toLocaleString() ?? ''}坪
                      {'  '}
                      {buildingInfoBasicData?.sagyosyoCd}
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem col={1} colSpan={3} row={7}>
                    <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                      備考： {buildingInfoBasicData?.remark}
                    </span>
                  </GridLayoutItem>
                </GridLayout>
              </GridLayoutItem>
              <GridLayoutItem col={3}>
                <GridLayout
                  gap={{ cols: 1 }}
                  rows={[
                    { height: '0.8em' },
                    { height: '0.8em' },
                    { height: '0.8em' },
                    { height: '0.8em' },
                    { height: '0.8em' },
                    { height: '0.8em' }
                  ]}
                >
                  <GridLayoutItem col={1} row={1}>
                    <span style={{ fontSize: '0.8em' }}>工事部</span>
                  </GridLayoutItem>
                  <GridLayoutItem col={2} row={1}>
                    <span style={{ fontSize: '0.8em' }}>
                      {buildingInfoBasicData?.constructionSectionNm}）
                      {buildingInfoBasicData?.chiefPersonNm}
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem col={2} row={2}>
                    <span style={{ fontSize: '0.8em' }}>
                      {buildingInfoBasicData?.chiefPersonContacts}
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem col={1} row={3}>
                    <span style={{ fontSize: '0.8em' }}>本社営業部</span>
                  </GridLayoutItem>
                  <GridLayoutItem col={2} row={3}>
                    <span style={{ fontSize: '0.8em' }}>
                      {buildingInfoBasicData?.hqSalesSectionNm}）
                      {buildingInfoBasicData?.hqSalesPersonNm}
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem col={2} row={4}>
                    <span style={{ fontSize: '0.8em' }}>
                      {buildingInfoBasicData?.hqSalesPersonContacts}
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem col={1} row={5}>
                    <span style={{ fontSize: '0.8em' }}>支店営業部</span>
                  </GridLayoutItem>
                  <GridLayoutItem col={2} row={5}>
                    <span style={{ fontSize: '0.8em' }}>
                      {buildingInfoBasicData?.branchSalesSectionNm}）
                      {buildingInfoBasicData?.branchSalesPersonNm}
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem col={2} row={6}>
                    <span style={{ fontSize: '0.8em' }}>
                      {buildingInfoBasicData?.branchSalesPersonContacts}
                    </span>
                  </GridLayoutItem>
                  <>
                    <GridLayoutItem col={1} row={7}>
                      <span style={{ fontSize: '0.8em' }}>発注者</span>
                    </GridLayoutItem>
                    <GridLayoutItem col={2} row={7}>
                      <span style={{ fontSize: '0.8em' }}>
                        {buildingInfoBasicData?.customerNm}
                      </span>
                    </GridLayoutItem>
                    <GridLayoutItem col={3} row={7}>
                      <span style={{ fontSize: '0.8em' }}>
                        {buildingInfoBasicData?.collabCustomerNm}
                      </span>
                    </GridLayoutItem>
                    <GridLayoutItem col={1} row={8}>
                      <span style={{ fontSize: '0.8em' }}>設計</span>
                    </GridLayoutItem>
                    <GridLayoutItem col={2} row={8}>
                      <span style={{ fontSize: '0.8em' }}>
                        {buildingInfoBasicData?.designKbnNmStr}
                      </span>
                    </GridLayoutItem>
                    <GridLayoutItem col={2} row={9}>
                      <span style={{ fontSize: '0.8em' }}>
                        {buildingInfoBasicData?.designerNm}
                      </span>
                    </GridLayoutItem>
                  </>
                </GridLayout>
              </GridLayoutItem>
            </GridLayout>
          </CardBody>
        </Card>

        <Label style={{ fontWeight: 'bold' }}>分割比率設定（単位：％）</Label>
        <Card orientation="horizontal" style={{ margin: '10px 0px' }}>
          <CardBody>
            <GridLayout gap={{ rows: 5, cols: 5 }}>
              <GridLayoutItem
                col={1}
                row={1}
                style={{ width: '320px', overflow: 'auto' }}
              >
                <GridLayout
                  cols={[
                    { width: 80 },
                    { width: 80 },
                    { width: 80 },
                    { width: 80 }
                  ]}
                >
                  {ratioList.map((ratio: number, index: number) =>
                    index !== ratioList.length - 1
                      ? (
                      <GridLayoutItem
                        key={index.toString()}
                        col={index + 1}
                        row={1}
                        style={{ width: '80px' }}
                      >
                        <NumericTextBox
                          style={{
                            fontWeight: 'bold',
                            fontSize: '1.0em',
                            width: '80%'
                          }}
                          value={ratio}
                          min={0}
                          max={100}
                          onChange={(e) => onChangeRatioList(e, index)}
                        />
                        <span style={{ fontWeight: 'bold', fontSize: '1.0em' }}>
                          /
                        </span>
                      </GridLayoutItem>
                        )
                      : (
                      <GridLayoutItem
                        key={index.toString()}
                        col={index + 1}
                        row={1}
                        style={{ width: '80px' }}
                      >
                        <NumericTextBox
                          style={{
                            fontWeight: 'bold',
                            fontSize: '1.0em',
                            width: '80%'
                          }}
                          value={ratio}
                          min={0}
                          max={100}
                          onChange={(e) => onChangeRatioList(e, index)}
                        />
                      </GridLayoutItem>
                        )
                  )}
                </GridLayout>
              </GridLayoutItem>
              <GridLayoutItem col={2} row={1}>
                <ButtonGroup>
                  <Button onClick={addRatioList} className="pcy-button-short">
                    追加
                  </Button>
                  <Button
                    onClick={clearRatioList}
                    className="pcy-button-short"
                    disabled={ratioList.length === 1 || false}
                  >
                    削除
                  </Button>
                </ButtonGroup>
              </GridLayoutItem>
              <GridLayoutItem
                col={4}
                colSpan={6}
                row={1}
                style={{ textAlign: 'right' }}
              >
                <Button
                  onClick={onShowInputArea}
                  themeColor="primary"
                  className="pcy-button-long"
                >
                  分割比率確定
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </CardBody>
        </Card>

        <>
          <Label style={{ fontWeight: 'bold', marginTop: '40px' }}>
            分割後物件情報
          </Label>
          {showInputArea && (
            <>
              {buildingInfoSplitList.map((buildingInfoSplit, index) => (
                <div key={`${buildingInfoSplit.buildingInfo.procurementNo ?? ''}-${index}`}>
                  <Tooltip position={'right'} parentTitle={true} className={'pcy-tooltip'}>
                    <Card orientation="horizontal" style={{ margin: '1% 0%' }}>
                      <CardHeader style={{ padding: '1% 0.5%', width: '16%' }}>
                        <CardTitle style={{ marginTop: '0px' }}>
                          <BranchSelect
                            onChange={(valueList) => { handleBranchCdList(index, valueList) }}
                            style={{
                              fontWeight: 'bold',
                              fontSize: '1.5em',
                              width: '70%'
                            }}
                            value={[buildingInfoSplit.buildingInfo.branchCd ?? '']}
                            popupSettings={{ className: 'pcy-dropdownlist', popupClass: 'pcy-dropdownlist-innner' }}
                            clear={true}
                            title={'支店（入力必須）'}
                            className={'pcy-disabled-field'}
                          />
                        </CardTitle>
                        <CardSubtitle style={{ marginTop: '0px' }}>
                          <EvaluationSelect
                            onChange={(valueList) => { handleValuationValueCd(index, valueList) }}
                            style={{
                              fontSize: '1.25em',
                              fontWeight: 'bold',
                              width: '70%'
                            }}
                            value={[buildingInfoSplit.buildingInfo.evaluationValueCd ?? '']}
                            popupSettings={{ className: 'pcy-dropdownlist', popupClass: 'pcy-dropdownlist-innner' }}
                            clear={true}
                            title={'評価値（入力必須）'}
                            className={'pcy-disabled-field'}
                          />
                        </CardSubtitle>
                        <CardSubtitle style={{ marginTop: '0px' }}>
                          <span style={{ fontWeight: 'bold', fontSize: '1em' }}>
                            選択と集中:
                          </span>
                          <AvailabilityStatusSelect
                            onChange={(valueList) => { handleChoiceAndConcentrationTarget(index, valueList) }}
                            style={{
                              fontSize: '1.25em',
                              fontWeight: 'bold',
                              width: '35%'
                            }}
                            value={
                              buildingInfoSplit.buildingInfo.dispChoiceAndConcentrationTarget !== undefined
                                ? [String(buildingInfoSplit.buildingInfo.dispChoiceAndConcentrationTarget)]
                                : undefined
                            }
                            popupSettings={{ className: 'pcy-dropdownlist', popupClass: 'pcy-dropdownlist-innner' }}
                            clear={true}
                            title={'選択と集中'}
                            className={'pcy-disabled-field'}
                          />
                        </CardSubtitle>
                        <CardSubtitle style={{ marginTop: '0px' }}>
                          <span
                            style={{
                              fontSize: '1.25em',
                              fontWeight: 'bold',
                              color: 'red'
                            }}
                          >
                            {buildingInfoSplit.buildingInfo.updSts}
                          </span>
                        </CardSubtitle>
                      </CardHeader>
                      <CardBody style={{ padding: '1% 0.5%' }}>
                        <GridLayout cols={[{ width: '73%' }, { width: '27%' }]}>
                          <GridLayoutItem
                            col={1}
                            style={{ marginLeft: 10, marginRight: 10 }}
                          >
                            <GridLayout>
                              <GridLayoutItem col={1} colSpan={3} row={1}>
                                <Input
                                  onChange={(e) => { handleConstructionNm(index, e) }}
                                  style={{ fontWeight: 'bold', fontSize: '1.0em' }}
                                  value={buildingInfoSplit.buildingInfo.dispConstructionNm ?? ''}
                                  type={'text'}
                                  title={'工事名（入力必須）'}
                                  placeholder={'工事名（入力必須）'}
                                  className={'pcy-disabled-field'}
                                />
                              </GridLayoutItem>
                              <GridLayoutItem col={1} row={2}>
                                <NumericTextBox
                                  onChange={(e) => { handleConstructionSubjectCd(index, e) }}
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.8em',
                                    width: '11%',
                                    height: '80%'
                                  }}
                                  value={
                                    buildingInfoSplit.buildingInfo.dispConstructionSubjectCd !== null
                                      ? Number(buildingInfoSplit.buildingInfo.dispConstructionSubjectCd)
                                      : null
                                  }
                                  max={999999}
                                  format={'#'}
                                  spinners={false}
                                  title={'工事科目コード'}
                                  placeholder={'工事科目コード'}
                                  className={'pcy-disabled-field'}
                                />
                                <ProcurementStatusSelect
                                  onChange={(valueList) => { handleProcurementSts(index, valueList) }}
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.7em',
                                    width: '12%',
                                    height: '80%'
                                  }}
                                  value={[buildingInfoSplit.buildingInfo.procurementSts ?? '']}
                                  popupSettings={{ className: 'pcy-dropdownlist', popupClass: 'pcy-dropdownlist-innner' }}
                                  clear={true}
                                  title={'調達状況'}
                                  className={'pcy-disabled-field'}
                                />
                                <ObtainHistorySelect
                                  onChange={(valueList) => { handleObtainHistoryCd(index, valueList) }}
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.7em',
                                    width: '10%',
                                    height: '80%'
                                  }}
                                  value={[buildingInfoSplit.buildingInfo.dispObtainHistoryCd ?? '']}
                                  popupSettings={{ className: 'pcy-dropdownlist', popupClass: 'pcy-dropdownlist-innner' }}
                                  clear={true}
                                  title={'入手経緯'}
                                  className={'pcy-disabled-field'}
                                />
                                <ConstrFormSelect
                                  value={[buildingInfoSplit.buildingInfo.dispConstructionFormCd ?? '']}
                                  onChange={(valueList) => { handleConstructionFormCd(index, valueList) }}
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.7em',
                                    width: '18%',
                                    height: '80%'
                                  }}
                                  popupSettings={{ className: 'pcy-dropdownlist', popupClass: 'pcy-dropdownlist-innner' }}
                                  clear={true}
                                  title={'施工形式'}
                                  className={'pcy-disabled-field'}
                                />
                                <NumericTextBox
                                  onChange={(event) => { handleOurCompanyEquityRatio(index, event) }}
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.8em',
                                    width: '9%',
                                    height: '80%'
                                  }}
                                  value={buildingInfoSplit.buildingInfo.dispOurCompanyEquityRatio}
                                  max={100}
                                  spinners={false}
                                  title={'当社持分比'}
                                  placeholder={'当社持分比'}
                                  className={'pcy-disabled-field'}
                                />
                                <span style={{ fontWeight: 'bold', fontSize: '0.8em', width: '8%' }}>
                                  %
                                </span>
                                <EffortLevelSelect
                                  onChange={(event) => { handleEffortLevel(index, event) }}
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.7em',
                                    width: '15%',
                                    height: '80%'
                                  }}
                                  value={[buildingInfoSplit.buildingInfo.dispEffortLevelCd ?? '']}
                                  popupSettings={{ className: 'pcy-dropdownlist', popupClass: 'pcy-dropdownlist-innner' }}
                                  clear={true}
                                  title={'取組レベル'}
                                  className={'pcy-disabled-field'}
                                />
                                <span style={{ fontWeight: 'bold', fontSize: '0.8em', width: '8%' }}>
                                  コアトップ案件:
                                </span>
                                <AvailabilityStatusSelect
                                  onChange={(valueList) => { handleCoreTopFlg(index, valueList) }}
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.7em',
                                    width: '8%',
                                    height: '80%'
                                  }}
                                  value={
                                    buildingInfoSplit.buildingInfo.dispCoreTopFlg !== undefined
                                      ? [String(buildingInfoSplit.buildingInfo.dispCoreTopFlg)]
                                      : undefined
                                  }
                                  popupSettings={{ className: 'pcy-dropdownlist', popupClass: 'pcy-dropdownlist-innner' }}
                                  clear={true}
                                  className={'pcy-disabled-field'}
                                />
                              </GridLayoutItem>
                              <GridLayoutItem col={1} row={3}>
                                <FiscalYearDropDownList
                                  disabled={obtainFyDisabled}
                                  onYearChange={(year) => { handleObtainFy(index, year) }}
                                  fyddlStyle={{
                                    fontWeight: 'bold',
                                    fontSize: '0.7em',
                                    width: '10%',
                                    height: '80%'
                                  }}
                                  origin={-5}
                                  range={16}
                                  fyddlValue={
                                    buildingInfoSplit.buildingInfo.dispObtainFY !== null && buildingInfoSplit.buildingInfo.dispObtainFY !== ''
                                      ? Number(buildingInfoSplit.buildingInfo.dispObtainFY)
                                      : undefined
                                  }
                                  popupSettings={{ className: 'pcy-dropdownlist', popupClass: 'pcy-dropdownlist-innner' }}
                                  clear={true}
                                  fyTitle={'入手年度（入力必須）'}
                                  className={'pcy-disabled-field'}
                                />
                                <PrefectureSelect
                                  onChange={(valueList) => { handlePrefecture(index, valueList) }}
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.7em',
                                    width: '12%',
                                    height: '80%'
                                  }}
                                  value={[buildingInfoSplit.buildingInfo.dispPrefecture ?? '']}
                                  popupSettings={{ className: 'pcy-dropdownlist', popupClass: 'pcy-dropdownlist-innner' }}
                                  clear={true}
                                  title={'都道府県'}
                                  className={'pcy-disabled-field'}
                                />
                                <Input
                                  onChange={(e) => { handleCityName(index, e) }}
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.8em',
                                    width: '9%',
                                    height: '80%'
                                  }}
                                  value={buildingInfoSplit.buildingInfo.dispCity ?? ''}
                                  type={'text'}
                                  title={'市区町村'}
                                  placeholder={'市区町村'}
                                  className={'pcy-disabled-field'}
                                />
                                <span style={{ fontWeight: 'bold', fontSize: '0.8em', paddingLeft: '2%' }}>
                                  総工事金額（百万）：￥
                                </span>
                                <NumericTextBox
                                  onChange={(e) => { handleTotalCost(index, e) }}
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.8em',
                                    width: '10%',
                                    height: '80%'
                                  }}
                                  value={buildingInfoSplit.buildingInfo.dispTotalCost}
                                  spinners={false}
                                  className={'pcy-disabled-field'}
                                />
                                <span style={{ fontWeight: 'bold', fontSize: '0.8em', paddingLeft: '2%' }}>
                                  当社概算工事金額（百万）：￥
                                </span>
                                <NumericTextBox
                                  onChange={(e) => { handleOurCompanyTotalCost(index, e) }}
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.8em',
                                    width: '10%',
                                    height: '80%'
                                  }}
                                  value={buildingInfoSplit.buildingInfo.dispOurCompanyTotalCost}
                                  spinners={false}
                                  className={'pcy-disabled-field'}
                                />
                              </GridLayoutItem>
                              <GridLayoutItem col={1} row={4}>
                                <ConstrTypeSelect
                                  onChange={(valueList) => { handleConstrucionCd(index, valueList) }}
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.7em',
                                    width: '10%',
                                    height: '80%'
                                  }}
                                  value={[buildingInfoSplit.buildingInfo.dispConstructionCd ?? '']}
                                  popupSettings={{ className: 'pcy-dropdownlist', popupClass: 'pcy-dropdownlist-innner' }}
                                  clear={true}
                                  title={'工事種別'}
                                  className={'pcy-disabled-field'}
                                />
                                <BuildingUsecaseDropDownList
                                  onChange={(valueList) => { handleArchitectureUse(index, valueList) }}
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.7em',
                                    width: '18%',
                                    height: '80%'
                                  }}
                                  value={buildingInfoSplit.buildingInfo.architectureUse ?? ''}
                                  popupSettings={{ className: 'pcy-dropdownlist', popupClass: 'pcy-dropdownlist-innner' }}
                                  clear={true}
                                  title={'建物用途（入力必須）'}
                                  className={'pcy-disabled-field'}
                                />
                                <span
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.8em'
                                  }}
                                >
                                  （
                                </span>
                                <StructureTypeSelect
                                  onChange={(valueList) => { handleDispStructureUnderground(index, valueList) }}
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.7em',
                                    width: '13%',
                                    height: '80%'
                                  }}
                                  value={[buildingInfoSplit.buildingInfo.dispStructureUnderGround ?? '']}
                                  popupSettings={{ className: 'pcy-dropdownlist', popupClass: 'pcy-dropdownlist-innner' }}
                                  clear={true}
                                  title={'構造・地下（入力必須）'}
                                  className={'pcy-disabled-field'}
                                />
                                <span
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.8em'
                                  }}
                                >
                                  /
                                </span>
                                <StructureTypeSelect
                                  onChange={(valueList) => { handleDispStructureGround(index, valueList) }}
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.7em',
                                    width: '13%',
                                    height: '80%'
                                  }}
                                  value={[buildingInfoSplit.buildingInfo.dispStructureGround ?? '']}
                                  popupSettings={{ className: 'pcy-dropdownlist', popupClass: 'pcy-dropdownlist-innner' }}
                                  clear={true}
                                  title={'構造・地上（入力必須）'}
                                  className={'pcy-disabled-field'}
                                />
                                <span
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.8em'
                                  }}
                                >
                                  ）
                                </span>
                                <NumericTextBox
                                  onChange={(e) => handleDispTotalFloorAreaM2AndTsubo(index, e.target.value)}
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.8em',
                                    width: '10%',
                                    height: '80%'
                                  }}
                                  value={buildingInfoSplit.buildingInfo.dispTotalFloorAreaM2}
                                  spinners={false}
                                  title={'延床面積平米（入力必須）'}
                                  placeholder={'延床面積平米（入力必須）'}
                                  className={'pcy-disabled-field'}
                                />
                                <span
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.8em'
                                  }}
                                >
                                  ㎡/
                                </span>
                                <NumericTextBox
                                  readOnly
                                  disabled={true}
                                  value={buildingInfoSplit.buildingInfo.dispTotalFloorAreaTsubo}
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.8em',
                                    width: '10%',
                                    height: '80%'
                                  }}
                                  spinners={false}
                                  title={'延床面積坪（入力必須）'}
                                  placeholder={'延床面積坪（入力必須）'}
                                  className={'pcy-disabled-field'}
                                />
                                <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                                  坪 -（
                                </span>
                                <NumericTextBox
                                  onChange={(e) => { handleDispFloorUnderGround(index, e) }}
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.8em',
                                    width: '4%',
                                    height: '80%'
                                  }}
                                  value={buildingInfoSplit.buildingInfo.dispFloorUnderGround}
                                  spinners={false}
                                  title={'階数・地下（入力必須）'}
                                  placeholder={'階数・地下（入力必須）'}
                                  className={'pcy-disabled-field'}
                                />
                                <span
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.8em'
                                  }}
                                >
                                  /
                                </span>
                                <NumericTextBox
                                  onChange={(e) => { handleDispFloorGround(index, e) }}
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.8em',
                                    width: '4%',
                                    height: '80%'
                                  }}
                                  value={buildingInfoSplit.buildingInfo.dispFloorGround}
                                  spinners={false}
                                  title={'階数・地上（入力必須）'}
                                  placeholder={'階数・地上（入力必須）'}
                                  className={'pcy-disabled-field'}
                                />
                                <span
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.8em'
                                  }}
                                >
                                  /
                                </span>
                                <NumericTextBox
                                  onChange={(e) => { handleDispFloorPenthouse(index, e) }}
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.8em',
                                    width: '4%',
                                    height: '80%'
                                  }}
                                  value={buildingInfoSplit.buildingInfo.dispFloorPenthouse}
                                  spinners={false}
                                  title={'階数・塔屋（入力必須）'}
                                  placeholder={'階数・塔屋（入力必須）'}
                                  className={'pcy-disabled-field'}
                                />
                                <span
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.8em'
                                  }}
                                >
                                  ）
                                </span>
                              </GridLayoutItem>
                              <GridLayoutItem col={1} row={5}>
                                <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                                  設備工事:
                                </span>
                                <AvailabilityStatusSelect
                                  onChange={(valueList) => { handleDispBuildingServicesWorkFlg(index, valueList) }}
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.7em',
                                    width: '9.25%',
                                    height: '80%'
                                  }}
                                  value={
                                    buildingInfoSplit.buildingInfo
                                      .dispBuildingServicesWorkFlg !== undefined
                                      ? [
                                          String(
                                            buildingInfoSplit.buildingInfo
                                              .dispBuildingServicesWorkFlg
                                          )
                                        ]
                                      : undefined
                                  }
                                  popupSettings={{ className: 'pcy-dropdownlist', popupClass: 'pcy-dropdownlist-innner' }}
                                  clear={true}
                                  title={'設備工事'}
                                  className={'pcy-disabled-field'}
                                />
                                <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                                  杭打:
                                </span>
                                <AvailabilityStatusSelect
                                  onChange={(valueList) => { handlePiling(index, valueList) }}
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.7em',
                                    width: '9.25%',
                                    height: '80%'
                                  }}
                                  value={
                                    buildingInfoSplit.buildingInfo.piling !==
                                    undefined
                                      ? [
                                          String(
                                            buildingInfoSplit.buildingInfo.piling
                                          )
                                        ]
                                      : undefined
                                  }
                                  popupSettings={{ className: 'pcy-dropdownlist', popupClass: 'pcy-dropdownlist-innner' }}
                                  clear={true}
                                  title={'杭打（入力必須）'}
                                  className={'pcy-disabled-field'}
                                />
                                <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                                  {' '}
                                  免震:
                                </span>
                                <AvailabilityStatusSelect
                                  onChange={(valueList) => { handleSeismicIsolation(index, valueList) }}
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.7em',
                                    width: '9.25%',
                                    height: '80%'
                                  }}
                                  value={
                                    buildingInfoSplit.buildingInfo
                                      .seismicIsolation !== undefined
                                      ? [
                                          String(
                                            buildingInfoSplit.buildingInfo
                                              .seismicIsolation
                                          )
                                        ]
                                      : undefined
                                  }
                                  popupSettings={{ className: 'pcy-dropdownlist', popupClass: 'pcy-dropdownlist-innner' }}
                                  clear={true}
                                  title={'免震（入力必須）'}
                                  className={'pcy-disabled-field'}
                                />
                                <span
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.8em'
                                  }}
                                >
                                  {' '}
                                </span>
                                <UnderGroundConstrMethodSelect
                                  onChange={(valueList) => { handleTopDown(index, valueList) }}
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.7em',
                                    width: '12.75%',
                                    height: '80%'
                                  }}
                                  value={
                                    buildingInfoSplit.buildingInfo.topDownFlg !==
                                    undefined
                                      ? [
                                          String(
                                            buildingInfoSplit.buildingInfo.topDownFlg
                                          )
                                        ]
                                      : undefined
                                  }
                                  popupSettings={{ className: 'pcy-dropdownlist', popupClass: 'pcy-dropdownlist-innner' }}
                                  title={'順打逆打（入力必須）'}
                                  className={'pcy-disabled-field'}
                                />
                                <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                                  {' '}
                                  工法:
                                </span>
                                <Input
                                  onChange={(e) => { handleSpecialConstructionMethodCd(index, e) }}
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.8em',
                                    width: '40%',
                                    height: '80%'
                                  }}
                                  value={buildingInfoSplit.buildingInfo.dispSpecialConstructionMethod ?? ''}
                                  title={'工法'}
                                  placeholder={'工法'}
                                  className={'pcy-disabled-field'}
                                />
                              </GridLayoutItem>
                              <GridLayoutItem col={1} colSpan={3} row={6}>
                                <FiscalMonthDropDownList
                                  onYearChange={(year) => {
                                    handleStartY(index, year)
                                    handleScheduleAuto({ index, sY: year })
                                  }}
                                  onMonthChange={(month) => {
                                    handleStartM(index, month)
                                    handleScheduleAuto({ index, sM: month })
                                  }}
                                  fyddlStyle={{
                                    fontWeight: 'bold',
                                    fontSize: '0.7em',
                                    width: '12%',
                                    height: '80%'
                                  }}
                                  fmddlStyle={{
                                    fontWeight: 'bold',
                                    fontSize: '0.7em',
                                    width: '12%',
                                    height: '80%'
                                  }}
                                  fyddlValue={
                                    buildingInfoSplit.buildingInfo.startY !==
                                      undefined &&
                                    buildingInfoSplit.buildingInfo.startY !== ''
                                      ? Number(
                                        buildingInfoSplit.buildingInfo.startY
                                      )
                                      : undefined
                                  }
                                  fmddlValue={
                                    buildingInfoSplit.buildingInfo.startM !==
                                      undefined &&
                                    buildingInfoSplit.buildingInfo.startM !== ''
                                      ? Number(
                                        buildingInfoSplit.buildingInfo.startM
                                      )
                                      : undefined
                                  }
                                  origin={-10}
                                  range={21}
                                  noDiv
                                  popupSettings={{ className: 'pcy-dropdownlist', popupClass: 'pcy-dropdownlist-innner' }}
                                  clear={true}
                                  fyTitle={'着工年（入力必須）'}
                                  fmTitle={'着工月（入力必須）'}
                                  className={'pcy-disabled-field'}
                                  fmClassName={'pcy-disabled-field'}
                                />
                                <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                                  -
                                </span>
                                <FiscalMonthDropDownList
                                  onYearChange={(year) => {
                                    handleCompletionY(index, year)
                                    handleScheduleAuto({ index, cY: year })
                                  }}
                                  onMonthChange={(month) => {
                                    handleCompletionM(index, month)
                                    handleScheduleAuto({ index, cM: month })
                                  }}
                                  fyddlStyle={{
                                    fontWeight: 'bold',
                                    fontSize: '0.7em',
                                    width: '12%',
                                    height: '80%'
                                  }}
                                  fmddlStyle={{
                                    fontWeight: 'bold',
                                    fontSize: '0.7em',
                                    width: '12%',
                                    height: '80%'
                                  }}
                                  fyddlValue={
                                    buildingInfoSplit.buildingInfo.completionY !==
                                      undefined &&
                                    buildingInfoSplit.buildingInfo.completionY !==
                                      ''
                                      ? Number(
                                        buildingInfoSplit.buildingInfo
                                          .completionY
                                      )
                                      : undefined
                                  }
                                  fmddlValue={
                                    buildingInfoSplit.buildingInfo.completionM !==
                                      undefined &&
                                    buildingInfoSplit.buildingInfo.completionM !==
                                      ''
                                      ? Number(
                                        buildingInfoSplit.buildingInfo
                                          .completionM
                                      )
                                      : undefined
                                    }
                                    origin={-10}
                                    range={31}
                                    noDiv
                                    popupSettings={{ className: 'pcy-dropdownlist', popupClass: 'pcy-dropdownlist-innner' }}
                                    clear={true}
                                    fyTitle={'竣工年（入力必須）'}
                                    fmTitle={'竣工月（入力必須）'}
                                    className={'pcy-disabled-field'}
                                    fmClassName={'pcy-disabled-field'}
                                />
                                <NumericTextBox
                                  onChange={(e) => { handleSchedule(index, e) }}
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.8em',
                                    width: '5%',
                                    height: '80%'
                                  }}
                                  value={buildingInfoSplit.buildingInfo.dispSchedule}
                                  spinners={false}
                                  title={'工期（入力必須）'}
                                  placeholder={'工期（入力必須）'}
                                  className={'pcy-disabled-field'}
                                />
                                <span
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.8em'
                                  }}
                                >
                                  ヶ月
                                </span>
                                <span style={{ marginLeft: '5px' }}></span>
                                <NumericTextBox
                                  onChange={(e) => handleDispSiteAreaM2AndTsubo(index, e.target.value)}
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.8em',
                                    width: '10%',
                                    height: '80%'
                                  }}
                                  value={buildingInfoSplit.buildingInfo.dispSiteAreaM2}
                                  spinners={false}
                                  title={'敷地面積平米'}
                                  placeholder={'敷地面積平米'}
                                  className={'pcy-disabled-field'}
                                />
                                <span
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.8em'
                                  }}
                                >
                                  ㎡/
                                </span>
                                <NumericTextBox
                                  readOnly
                                  disabled={true}
                                  value={buildingInfoSplit.buildingInfo.dispSiteAreaTsubo}
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.8em',
                                    width: '10%',
                                    height: '80%'
                                  }}
                                  spinners={false}
                                  title={'敷地面積坪'}
                                  placeholder={'敷地面積坪'}
                                  className={'pcy-disabled-field'}
                                />
                                <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                                  坪
                                </span>
                                <span style={{ marginLeft: '5px' }}></span>
                                <NumericTextBox
                                  onChange={(e) => { handleSagyosyoCd(index, e) }}
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.8em',
                                    width: '11%',
                                    height: '80%'
                                  }}
                                  value={
                                    buildingInfoSplit.buildingInfo.dispSagyosyoCd !== null
                                      ? Number(buildingInfoSplit.buildingInfo.dispSagyosyoCd)
                                      : null
                                  }
                                  max={999999}
                                  format={'#'}
                                  spinners={false}
                                  title={'作業所コード'}
                                  placeholder={'作業所コード'}
                                  className={'pcy-disabled-field'}
                                />
                              </GridLayoutItem>
                              <GridLayoutItem col={1} row={7}>
                                <span
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.8em'
                                  }}
                                >
                                  備考:
                                </span>
                                <TextArea
                                  onChange={(e) => {
                                    handleRemark(index, e)
                                  }}
                                  value={
                                    buildingInfoSplit.buildingInfo.remark ?? ''
                                  }
                                />
                              </GridLayoutItem>
                            </GridLayout>
                          </GridLayoutItem>

                          <GridLayoutItem col={2}>
                            <GridLayout
                              gap={{ cols: 1 }}
                              cols={[{ width: '25%' }, { width: '75%' }]}
                            >
                              <GridLayoutItem col={1} row={1}>
                                <span style={{ fontSize: '0.8em' }}>工事部</span>
                              </GridLayoutItem>
                              <GridLayoutItem col={2} row={1}>
                                <Input
                                  onChange={(e) => { handleConstructionSectionNm(index, e) }}
                                  style={{
                                    fontWeight: 'normal',
                                    fontSize: '0.8em',
                                    width: '54%',
                                    height: '80%'
                                  }}
                                  value={buildingInfoSplit.buildingInfo.dispConstructionSectionNm ?? ''}
                                  type={'text'}
                                  title={'工事部名'}
                                  placeholder={'工事部名'}
                                  className={'pcy-disabled-field'}
                                />
                                <span style={{ fontSize: '0.8em' }}>）</span>
                                <Input
                                  onChange={(e) => { handleChiefPersonNm(index, e) }}
                                  style={{
                                    fontWeight: 'normal',
                                    fontSize: '0.8em',
                                    width: '40%',
                                    height: '80%'
                                  }}
                                  value={buildingInfoSplit.buildingInfo.dispChiefPersonNm ?? ''}
                                  type={'text'}
                                  title={'所長担当者名'}
                                  placeholder={'所長担当者名'}
                                  className={'pcy-disabled-field'}
                                />
                              </GridLayoutItem>
                              <GridLayoutItem col={2} row={2}>
                                <Input
                                  onChange={(e) => { handleChiefPersonContacts(index, e) }}
                                  style={{
                                    fontWeight: 'normal',
                                    fontSize: '0.8em',
                                    width: '100%',
                                    height: '80%'
                                  }}
                                  value={buildingInfoSplit.buildingInfo.dispChiefPersonContacts ?? ''}
                                  type={'text'}
                                  title={'所長担当者連絡先'}
                                  placeholder={'所長担当者連絡先'}
                                  className={'pcy-disabled-field'}
                                />
                              </GridLayoutItem>
                              <GridLayoutItem col={1} row={3}>
                                <span style={{ fontSize: '0.8em' }}>
                                  本社営業部
                                </span>
                              </GridLayoutItem>
                              <GridLayoutItem col={2} row={3}>
                                <Input
                                  onChange={(e) => { handleHqSalesSectionNm(index, e) }}
                                  style={{
                                    fontWeight: 'normal',
                                    fontSize: '0.8em',
                                    width: '54%',
                                    height: '80%'
                                  }}
                                  value={buildingInfoSplit.buildingInfo.dispHqSalesSectionNm ?? ''}
                                  type={'text'}
                                  title={'本社営業部名'}
                                  placeholder={'本社営業部名'}
                                  className={'pcy-disabled-field'}
                                />
                                <span style={{ fontSize: '0.8em' }}>）</span>
                                <Input
                                  onChange={(e) => { handleHqSalesPersonNm(index, e) }}
                                  style={{
                                    fontWeight: 'normal',
                                    fontSize: '0.8em',
                                    width: '40%',
                                    height: '80%'
                                  }}
                                  value={buildingInfoSplit.buildingInfo.dispHqSalesPersonNm ?? ''}
                                  type={'text'}
                                  title={'本社営業担当者名'}
                                  placeholder={'本社営業担当者名'}
                                  className={'pcy-disabled-field'}
                                />
                              </GridLayoutItem>
                              <GridLayoutItem col={2} row={4}>
                                <Input
                                  onChange={(e) => { handleHqSalesPersonContacts(index, e) }}
                                  style={{
                                    fontWeight: 'normal',
                                    fontSize: '0.8em',
                                    width: '100%',
                                    height: '80%'
                                  }}
                                  value={buildingInfoSplit.buildingInfo.dispHqSalesPersonContacts ?? ''}
                                  type={'text'}
                                  title={'本社営業担当者連絡先'}
                                  placeholder={'本社営業担当者連絡先'}
                                  className={'pcy-disabled-field'}
                                />
                              </GridLayoutItem>
                              <GridLayoutItem col={1} row={5}>
                                <span style={{ fontSize: '0.8em' }}>
                                  支店営業部
                                </span>
                              </GridLayoutItem>
                              <GridLayoutItem col={2} row={5}>
                                <Input
                                  onChange={(e) => { handleBranchSalesSectionNm(index, e) }}
                                  style={{
                                    fontWeight: 'normal',
                                    fontSize: '0.8em',
                                    width: '54%',
                                    height: '80%'
                                  }}
                                  value={buildingInfoSplit.buildingInfo.dispBranchSalesSectionNm ?? ''}
                                  type={'text'}
                                  title={'支店営業部名'}
                                  placeholder={'支店営業部名'}
                                  className={'pcy-disabled-field'}
                                />
                                <span style={{ fontSize: '0.8em' }}>）</span>
                                <Input
                                  onChange={(e) => { handleBranchSalesPersonNm(index, e) }}
                                  style={{
                                    fontWeight: 'normal',
                                    fontSize: '0.8em',
                                    width: '40%',
                                    height: '80%'
                                  }}
                                  value={buildingInfoSplit.buildingInfo.dispBranchSalesPersonNm ?? ''}
                                  type={'text'}
                                  title={'支店営業担当者名'}
                                  placeholder={'支店営業担当者名'}
                                  className={'pcy-disabled-field'}
                                />
                              </GridLayoutItem>
                              <GridLayoutItem col={2} row={6}>
                                <Input
                                  onChange={(e) => { handleBranchSalesPersonContacts(index, e) }}
                                  style={{
                                    fontWeight: 'normal',
                                    fontSize: '0.8em',
                                    width: '100%',
                                    height: '80%'
                                  }}
                                  value={buildingInfoSplit.buildingInfo.dispBranchSalesPersonContacts ?? ''}
                                  type={'text'}
                                  title={'支店営業担当者連絡先'}
                                  placeholder={'支店営業担当者連絡先'}
                                  className={'pcy-disabled-field'}
                                />
                              </GridLayoutItem>
                              <GridLayoutItem col={1} row={7}>
                                <span style={{ fontSize: '0.8em' }}>発注者</span>
                              </GridLayoutItem>
                              <GridLayoutItem col={2} row={7}>
                                <Input
                                  onChange={(e) => { handleCustomerNm(index, e) }}
                                  style={{
                                    fontWeight: 'normal',
                                    fontSize: '0.8em',
                                    width: '50%',
                                    height: '80%'
                                  }}
                                  value={buildingInfoSplit.buildingInfo.dispCustomerNm ?? ''}
                                  type={'text'}
                                  title={'発注者名'}
                                  placeholder={'発注者名'}
                                  className={'pcy-disabled-field'}
                                />
                                <Input
                                  onChange={(e) => { handleCollabCustomerNm(index, e) }}
                                  style={{
                                    fontWeight: 'normal',
                                    fontSize: '0.8em',
                                    width: '50%',
                                    height: '80%'
                                  }}
                                  value={buildingInfoSplit.buildingInfo.dispCollabCustomerNm ?? ''}
                                  type={'text'}
                                  title={'共同発注者名'}
                                  placeholder={'共同発注者名'}
                                  className={'pcy-disabled-field'}
                                />
                              </GridLayoutItem>
                              <GridLayoutItem col={1} row={8}>
                                <span style={{ fontSize: '0.8em' }}>設計</span>
                              </GridLayoutItem>
                              <GridLayoutItem col={2} row={8}>
                                <DesignClassificationSelect
                                  onChange={(valueList) => { handleDesignKbnNm(index, valueList) }}
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.7em',
                                    width: '100%',
                                    height: '80%'
                                  }}
                                  value={[buildingInfoSplit.buildingInfo.dispDesignKbn ?? '']}
                                  popupSettings={{ className: 'pcy-dropdownlist', popupClass: 'pcy-dropdownlist-innner' }}
                                  clear={true}
                                  title={'設計区分'}
                                  className={'pcy-disabled-field'}
                                />
                              </GridLayoutItem>
                              <GridLayoutItem col={2} row={9}>
                                <Input
                                  onChange={(e) => { handleInputDesignerNm(index, e) }}
                                  style={{
                                    fontWeight: 'normal',
                                    fontSize: '0.8em',
                                    width: '50%',
                                    height: '80%'
                                  }}
                                  value={buildingInfoSplit.buildingInfo.dispDesignerNm ?? ''}
                                  type={'text'}
                                  title={'設計者名'}
                                  placeholder={'設計者名'}
                                  className={'pcy-disabled-field'}
                                />
                              </GridLayoutItem>
                            </GridLayout>
                          </GridLayoutItem>
                        </GridLayout>
                      </CardBody>
                    </Card>
                    <GridLayout style={{ marginTop: '2%' }}>
                      <GridLayoutItem>
                        <span style={{ fontWeight: 'bold' }}>修正コメント</span>
                        <TextArea
                          onChange={(e) => {
                            handleFixComment(index, e)
                          }}
                          value={buildingInfoSplit.buildingInfo.fixComment ?? ''}
                        ></TextArea>
                      </GridLayoutItem>
                    </GridLayout>
                  </Tooltip>
                </div>
              ))}
            </>
          )}
        </>
      </>
    </Contents>
  )
}
